const originalData = [
  [67, 215],
  [67, 211],
  [64, 209],
  [64, 210],
  [191, 289],
  [804, 681],
  [192, 307],
  [123, 234],
  [228, 266],
  [125, 220],
  [88, 231],
  [384, 378],
  [362, 356],
  [150, 305],
  [500, 517],
  [533, 540],
  [369, 364],
  [389, 385],
  [136, 196],
  [526, 477],
  [661, 662],
  [542, 485],
  [429, 415],
  [369, 376],
  [338, 365],
  [314, 349],
  [291, 330],
  [276, 317],
  [264, 324],
  [252, 269],
  [304, 293],
  [305, 296],
  [187, 198],
  [242, 243],
  [150, 209],
  [640, 533],
  [816, 723],
  [776, 700],
  [321, 304],
  [442, 417],
  [439, 421],
  [488, 484],
  [452, 429],
  [452, 427],
  [452, 429],
  [509, 482],
  [474, 477],
  [82, 0],
  [80, 0],
  [80, 0],
  [70, 0],
  [69, 0],
  [68, 0],
  [67, 0],
  [67, 0],
  [70, 0],
  [69, 0],
  [69, 0],
  [68, 0],
  [68, 0],
  [67, 0],
  [67, 0],
  [66, 0],
  [66, 0],
  [66, 0],
  [65, 0],
  [65, 0],
  [65, 0],
  [65, 0],
  [64, 0],
  [64, 0],
  [63, 0],
  [64, 0],
  [63, 0],
  [63, 0],
  [63, 0],
  [62, 0],
  [62, 0],
  [62, 0],
  [62, 0],
  [65, 0],
  [64, 0],
  [64, 0],
  [64, 0],
  [63, 0],
  [63, 0],
  [63, 0],
  [63, 0],
  [63, 0],
  [63, 0],
  [62, 0],
  [62, 0],
  [62, 0],
  [62, 0],
  [62, 0],
  [62, 0],
  [62, 0],
  [62, 0],
  [62, 0],
  [62, 0],
  [61, 0],
  [61, 0],
  [61, 0],
  [61, 0],
  [61, 0],
  [61, 0],
  [61, 0],
  [60, 0],
  [60, 0],
  [61, 0],
  [61, 0],
  [60, 0],
  [60, 0],
  [60, 0],
  [60, 0],
  [60, 0],
  [60, 0],
  [60, 0],
  [60, 0],
  [60, 0],
  [60, 0],
  [60, 0],
  [60, 0],
  [60, 0],
  [60, 0],
  [60, 0],
  [60, 0],
  [54, 0],
  [53, 0],
  [53, 0],
  [73, 0],
  [703, 0],
  [706, 0],
  [87, 0],
  [62, 0],
  [64, 0],
  [68, 0],
  [66, 0],
  [67, 0],
  [65, 0],
  [67, 0],
  [68, 0],
  [65, 0],
  [64, 0],
  [64, 0],
  [62, 0],
  [63, 0],
  [64, 0],
  [117, 0],
  [125, 0],
  [106, 0],
  [100, 0],
  [207, 0],
  [129, 0],
  [141, 0],
  [127, 0],
  [296, 0],
  [265, 0],
  [152, 0],
  [150, 0],
  [149, 0],
  [148, 0],
  [147, 0],
  [145, 0],
  [296, 0],
  [252, 0],
  [222, 0],
  [193, 0],
  [165, 0],
  [149, 0],
  [138, 0],
  [132, 0],
  [127, 0],
  [119, 0],
  [116, 0],
  [116, 0],
  [115, 0],
  [114, 0],
  [113, 0],
  [112, 0],
  [110, 0],
  [111, 0],
  [110, 0],
  [110, 0],
  [109, 0],
  [109, 0],
  [108, 0],
  [107, 0],
  [109, 0],
  [108, 0],
  [108, 0],
  [107, 0],
  [107, 0],
  [106, 0],
  [106, 0],
  [105, 0],
  [105, 0],
  [104, 0],
  [104, 0],
  [104, 0],
  [104, 0],
  [104, 0],
  [104, 0],
  [104, 0],
  [104, 0],
  [104, 0],
  [104, 0],
  [104, 0],
  [104, 0],
  [104, 0],
  [104, 0],
  [103, 0],
  [103, 0],
  [102, 0],
  [102, 0],
  [101, 0],
  [100, 0],
  [101, 0],
  [102, 0],
  [102, 0],
  [101, 0],
  [101, 0],
  [100, 0],
  [102, 0],
  [101, 0],
  [100, 0],
  [102, 0],
  [103, 0],
  [102, 0],
  [103, 0],
  [102, 0],
  [103, 0],
  [102, 0],
  [119, 0],
  [120, 0],
  [105, 0],
  [107, 0],
  [107, 0],
  [107, 0],
  [107, 0],
  [684, 0],
  [363, 0],
  [272, 0],
  [257, 0],
  [235, 0],
  [218, 0],
  [187, 0],
  [182, 0],
  [172, 0],
  [161, 0],
  [160, 0],
  [158, 0],
  [155, 0],
  [154, 0],
  [152, 0],
  [154, 0],
  [153, 0],
  [152, 0],
  [152, 0],
  [152, 0],
  [153, 0],
  [154, 0],
  [191, 0],
];

export default originalData;
